import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FaqHero from "./sections/FaqHero";
import GrownFromHeritage from "./sections/GrownFromHeritage";
import SolutionsGrid from "./sections/SolutionsGrid";
import KeyFeaturesGrid from "./sections/KeyFeaturesGrid";
import VantagensParaOBarbeiro from "./sections/VantagensParaOBarbeiro";
import GlobalOperations from "./sections/GlobalOperations";
import InnovationInsights from "./sections/InnovationInsights";
import StartYourProject from "./sections/StartYourProject";
import OurValuedClients from "./sections/OurValuedClients";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FaqHero />
      <GrownFromHeritage />
      <SolutionsGrid />
      <KeyFeaturesGrid />
      <VantagensParaOBarbeiro />
      <GlobalOperations />
      <InnovationInsights />
      <StartYourProject />
      <OurValuedClients />
      <FooterInformation />
    </div>;
}